module.exports = __webpack_public_path__ + "img/no-image.f36745c9.png";